'use client';

export default function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-orange-100">
      <div className="text-center">
        <div className="inline-block w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-orange-600">กำลังโหลด...</p>
      </div>
    </div>
  );
}

